export const HAS_SEEN_OFFERS = "hasSeenOffers";
